/**
 * Builds a localStorage key scoped to an org and/or user so that a preference
 * set for one org/user does not leak into another on the same browser.
 *
 * Missing ids fall back to `na`, e.g. buildScopedKey('foo', 'o1', 'u1')
 * → "foo::o1::u1".
 */
export const buildScopedKey = (
    base: string,
    orgId?: string,
    userId?: string,
): string => `${base}::${orgId ?? 'na'}::${userId ?? 'na'}`
